/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RegistrationApproveRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
